/*
 * @Author: Alan
 * @Date: 2023-06-14 15:11:45
 * @LastEditors: Connie
 * @LastEditTime: 2023-08-22 14:07:15
 * @Description: 404页面
 * @FilePath: /F1-M2-WEB-Code/pages/404.js
 */
import React from "react";
import RootLayout from "@/Layout";
import Layout from "@/Layout/other";
import { PopUpLiveChat } from "$ACTIONS/util";
import Link from "next/link";

//export時會被靜態頁面取代(moveFile.js)
export default function Custom404() {
    return (
        <RootLayout
            status={5}
        >
            <Layout>
                <div className="error-wrapper">
                    <div className="error-img">
                        <img
                            src="/th/img/error404/errorImage.jpg"
                            alt="404Image"
                        />
                    </div>
                    <div className="error-right">
                        <div className="error-item">
                            <p className="title">ไม่พบหน้านี้</p>
                            {/* 无法找到页面 */}
                            <div className="error-icon">
                                <img
                                    src="/th/img/error404/errorIcon.png"
                                    alt="404Icon"
                                />
                            </div>
                            <span className="error-mes">
                                หากคุณยังไม่พบหน้านี้ <br />
                                โปรดติดต่อฝ่ายบริการลูกค้าโดยเร็วที่สุด
                                {/* 您的网页暂时无法找到。若仍然无法打开页面，请您尽快联系客服。 */}
                            </span>
                            <Link href="/">
                                <a className="error-home-btn">
                                    <span>กลับสู่หน้าแรก</span>
                                </a>
                            </Link>
                            <button
                                className="error-chat-btn"
                                onClick={() => PopUpLiveChat()}
                            >
                                <img
                                    src="/th/img/error404/icon-cs.svg"
                                    alt="customerServiceIcon"
                                />
                                <span>ฝ่ายบริการลูกค้า</span>
                            </button>
                            <div className="error-information">
                                <div className="error-info-text">
                                    <span>อีเมล :</span>
                                    {/* 电子邮箱: */}
                                    <a href="mailto:cs.thai@fun88.com" style={{ paddingLeft: "6px" }}>cs.thai@fun88.com</a>
                                </div>
                                <div className="error-info-text">
                                    <span>โทรศัพท์ :</span>
                                    {/* 热线电话: */}
                                    <a href="#" style={{ paddingLeft: "6px" }}>+66 600 035 187</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </RootLayout>
    );
}
